import { Question } from '@jupiterone/jupiter-types/question';
import { MenuProps } from '@material-ui/core/Menu';
import { createStyles, makeStyles } from '@material-ui/styles';
import React from 'react';
import {
  Sun as HomeIcon,
  User as UserIcon,
  Users as TeamIcon,
} from 'react-feather';
import DropDownListMenu, {
  DropDownListMenuItem,
} from '@jupiterone/jupiter-web-toolkit/src/components/menus/DropDownListMenu';
import useAddToInsightsMenuLogic from './useAddToInsightsMenuLogic';

const useStyles = makeStyles(() =>
  createStyles({
    menuPaper: {
      width: 275,
    },
  })
);

interface Props extends Omit<MenuProps, 'onClose'> {
  questionId?: Question['id'];
  query?: string;
  onClose?: VoidFunction;
}

const AddToInsightsMenu = ({ questionId, query, onClose, ...props }: Props) => {
  const classes = useStyles();
  const {
    teamBoards,
    userBoards,
    isAdminInsight,
    handleAddToInsights,
  } = useAddToInsightsMenuLogic({
    questionId,
    query,
    onClose,
  });

  const listMenuItems = [
    {
      title: 'Home Dashboard',
      icon: <HomeIcon />,
      onClick: handleAddToInsights('home'),
    },
    isAdminInsight && {
      title: 'Team Boards',
      icon: <TeamIcon />,
      subMenuItems: teamBoards?.map((b) => ({
        title: b.name,
        onClick: handleAddToInsights('team', b.id),
      })),
    },
    {
      title: 'My Boards',
      icon: <UserIcon />,
      disabled: !userBoards || userBoards.length === 0,
      disabledTooltip:
        'Add personal dashboards from the Insights page side panel',
      subMenuItems: userBoards?.map((b) => ({
        title: b.name,
        onClick: handleAddToInsights('user', b.id),
      })),
    },
  ].filter((r) => r) as DropDownListMenuItem[];

  return (
    <DropDownListMenu
      id="add-to-insights-menu"
      title="Add to Insights"
      onClose={onClose}
      classes={{ paper: classes.menuPaper }}
      {...props}
    >
      {listMenuItems}
    </DropDownListMenu>
  );
};

export default AddToInsightsMenu;
